/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * ドクターカー・ドクターヘリ出動
 */
export type DrCarDrHeliDispatchEnum =
  (typeof DrCarDrHeliDispatchEnum)[keyof typeof DrCarDrHeliDispatchEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DrCarDrHeliDispatchEnum = {
  DISPATCHED: 'DISPATCHED',
  CANCELED_IN_ROUTE: 'CANCELED_IN_ROUTE',
  NONE: 'NONE',
} as const;
